import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {create} from "../../../app/setters/create.js";
import {useSelector} from "react-redux";

export const useInicjujSprawozdanie = () => {
    const rola = useSelector((state) => state.user.role);
    const roleParam = rola === 'oper' ? 'oper/' : '';
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => create(`/${roleParam}sprawozdanie/inicjuj`, data),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`lista_sprawozdan`),
            });
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`czy_mozna_inicjowac`),
            });
        },
        onSuccess: ({message}) => {
            toast.success(message)
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || 'Wystąpił błąd podczas inicjacji sprawozdania')
        }
    });
};
